import { Button } from '@/components/atoms/Button';
import { cn } from '@/styles/utils';
import Image from 'next/image';
import { useAllFilterStore } from '../../stores/AllFilterStore';
import { Filter } from '../../types/models/filter';

interface FilterSectionProps {
  filters: Filter[];
  onResetFilters: () => void;
  className?: string;
}

export function FilterSection({
  filters,
  onResetFilters,
  className,
}: FilterSectionProps) {
  const { toggleAllFilters } = useAllFilterStore();

  return (
    <div className={cn('relative flex items-center gap-4 body-14r', className)}>
      <Button
        variant="ghost"
        size="sm"
        className="p-2"
        onClick={() => {
          onResetFilters();
        }}
        disabled={!filters.some((f) => f.options.some((o) => o.selected))}
      >
        필터 초기화
      </Button>
      <Button
        variant="outline"
        size="sm"
        className="text-[#323B49] border-[#323B49] border px-4 py-1.5 gap-2 min-w-28 h-8"
        onClick={() => {
          toggleAllFilters();
        }}
      >
        전체 필터
        <Image
          src="/images/filter.svg"
          alt="all filters"
          width={20}
          height={20}
        />
      </Button>
    </div>
  );
}
